import { convertTimeWithTimezone } from '@/utils/time';
import { BoxV2 as Box } from 'portal-commons';
import React from 'react';
import { capitalize, snakeToTitleCase } from '@/utils';
import { useHistory, useLocation } from 'react-router-dom';
import { RcsCampaignListItem } from '../../types';
import { remapTCRStatus } from '../../utils';
import { faHourglass } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { RCS_CAMPAIGN_DETAILS_PATH } from '@/constants/paths';
import { UsecaseType } from '@/utils/types';

interface Props {
  campaign: RcsCampaignListItem;
  rcsUseCases: UsecaseType[];
}

const RcsCampaignListingRow: React.FC<Props> = ({ campaign, rcsUseCases }) => {
  const history = useHistory();
  const location = useLocation();

  const displayUsecase = (usecaseId: string) => {
    const usecase = rcsUseCases.find((useCase) => useCase.id === usecaseId);
    return usecase ? usecase.displayName : usecaseId;
  };

  const displayStatus = (status: string, isCapitalized = true) => {
    if (status === 'PENDING') {
      return (
        <Box as="span" sx={{ display: 'flex', alignItems: 'center', gap: 4 }}>
          {status === 'PENDING' && <FontAwesomeIcon icon={faHourglass} />}
          {isCapitalized ? capitalize(status) : status}
        </Box>
      );
    } else if (status === 'SIGNED') {
      return isCapitalized ? 'Complete' : 'COMPLETE';
    }
    return isCapitalized ? capitalize(status) : status;
  };

  const handleRowClick = () => {
    history.push({
      pathname: RCS_CAMPAIGN_DETAILS_PATH.replace(':id', campaign.uid),
      state: {
        goBackPage: location.pathname + location.search,
      },
    });
  };

  return (
    <Box as="tr" data-testid="campaignRow" onClick={handleRowClick}>
      <Box as="td" sx={{ width: 95, minWidth: 95 }} data-testid="campaignUid">
        {campaign.uid}
      </Box>
      {/* <Box
        as="td"
        sx={{ width: 125, minWidth: 125 }}
        data-testid="campaignDisplayName"
      >
        {campaign.displayName}
      </Box> */}
      <Box
        as="td"
        sx={{ width: 80, minWidth: 80 }}
        data-testid="campaignBrandUid"
      >
        {campaign.brandUid}
      </Box>
      <Box
        as="td"
        sx={{ width: 125, minWidth: 125, wordBreak: 'break-all' }}
        data-testid="campaignBrandName"
      >
        {campaign.brandName}
      </Box>
      <Box
        as="td"
        sx={{ width: 125, minWidth: 125 }}
        data-testid="campaignUsecase"
      >
        {displayUsecase(campaign.usecase)}
      </Box>
      <Box
        as="td"
        sx={{ width: 125, minWidth: 125 }}
        data-testid="campaignBillingCategory"
      >
        {snakeToTitleCase(campaign.billingCategory)}
      </Box>
      <Box
        as="td"
        sx={{ width: 125, minWidth: 125, wordBreak: 'break-all' }}
        data-testid="campaignUpstreamCnpName"
      >
        {campaign?.upstreamCnpName ?? 'N/A'}
      </Box>
      <Box
        as="td"
        sx={{ width: 125, minWidth: 125 }}
        data-testid="campaignCreateDate"
      >
        {convertTimeWithTimezone(campaign.createDate, undefined, 'MM/DD/YYYY')}
      </Box>
      <Box
        as="td"
        sx={{ width: 90, minWidth: 90 }}
        data-testid="campaignStatus"
      >
        {remapTCRStatus(campaign.status)}
      </Box>
    </Box>
  );
};

export default RcsCampaignListingRow;
